<template>
  <div class="container">
    <!--<div class="leftContainer">
            <p id="WelcomeMessage">Welcome to the Microsoft Authentication Library For Javascript Quickstart - MsAL</p>
            <button id="SignIn" @click="Login">Sign In</button>
        </div>
        <div class="rightContainer">
            <pre id="json"></pre>
        </div>-->
  </div>
</template>

<script>
export default {
  methods: {
    Login() {
      this.$authService.signIn().then(console.log(""));
    },
  },
};
</script>

<style></style>
